import { ListData } from "../types/List";
import { RoleActionData } from "../types/Role";
import { userApiUrl } from "./api";

const API_URL = "/Roles"; // Replace with your real endpoint

export const getRoleData = async (): Promise<ListData[]> => {
  try {
    const res = await userApiUrl.get<ListData[]>(API_URL);
    return res.data;
  } catch (error: any) {
    console.error(
      `Get all roles error: ${error.response?.data?.message || error.message}`
    );
    return []; // Return empty array on error
  }
};

export const getRolePermissionsData = async (): Promise<RoleActionData[]> => {
  try {
    const res = await userApiUrl.get<RoleActionData[]>(
      `${API_URL}/role-permissions`
    );
    return res.data;
  } catch (error: any) {
    console.error(
      `Get role permissions error: ${
        error.response?.data?.message || error.message
      }`
    );
    return [];
  }
};
